import type { ColorCode } from '@/modules/core/enums/color-code.enum.ts';
import type { DocumentColorLockSource, DocumentColorSources } from '@/modules/document/types/document-color.type.ts';

export type SourceColorLock = {
  color: ColorCode | null;
  source: Exclude<DocumentColorLockSource, 'document'> | null;
};

export const EMPTY_COLOR_SOURCES: DocumentColorSources = { types: {}, projects: {} };

export function findSourceColorLock(
  sources: DocumentColorSources,
  typeId: number,
  projectId: number | null
): SourceColorLock | null {
  if (sources.types[typeId]?.isLocked) {
    return { color: sources.types[typeId].color, source: 'documentType' };
  }

  if (projectId !== null && sources.projects[projectId]?.isLocked) {
    return { color: sources.projects[projectId].color, source: 'project' };
  }

  return null;
}
